<template>
  <div>
    <img src="./assets/nhjd.png" align="right" style="position: absolute;right: 5px;top:5px;height: 40px;width:146px;max-height:calc(10%);max-width: calc(30%)">
    <div id="app">
      <router-view/>
    </div>
  </div>

</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue